module.exports = __webpack_public_path__ + "static/media/tm6_10.f3341a93.svg";